<template>
  <div class="box c-p-t-20">
    <!-- <g-title t="绑定实体卡"></g-title> -->
    <div class="c-f-ar">
      <img src="@/assets/images/bindCard_icon.png" class="c-w-120" alt="" />
      <!-- <g-img :src="require('@/assets/images/bindCard_icon.png')"></g-img> -->
    </div>
    <div class="sub-top c-ct c-main-txt">绑定实体会员卡</div>
    <van-form validate-first @failed="onFailed">
      <!-- <van-field
        v-model="form.cardCode"
        type="number"
        placeholder="请输入会员卡卡号"
        :rules="[{ required: true }]"
      >
        <template #left-icon>
          <g-img
            :src="require('@/assets/images/mCard.png')"
            class="c-m-r-20"
            size="40"
          ></g-img>
        </template>
      </van-field> -->
      <van-field
        v-model="form.phone"
        placeholder="请输入手机号"
        maxlength="11"
        type="tel"
        clearable
        :rules="[{ required: true }]"
      >
        <template #left-icon>
          <g-img
            :src="require('@/assets/images/phone_icon.png')"
            class="l-img"
            size="40"
          ></g-img>
        </template>
        <template #right-icon>
          <g-send-code
            :disabled.sync="codeDiabled"
            :phone="form.phone"
            :click="sendCode"
            ref="sendRef"
            color="var(--tc)"
          ></g-send-code>
        </template>
      </van-field>

      <van-field
        v-model="form.code"
        clearable
        placeholder="请输入验证码"
        type="digit"
        maxlength="6"
      >
        <template #left-icon>
          <g-img
            :src="require('@/assets/images/pwd_icon.png')"
            class="l-img"
            size="40"
          ></g-img>
        </template>
      </van-field>
    </van-form>

    <van-checkbox-group
      v-model="memberList"
      v-if="list.length > 0"
      class="m-t-50 bg-white p-tb-10"
    >
      <g-title t="请选择会员卡" class="member_title c-p-lr-20"></g-title>
      <div v-for="(v, i) in list" :key="i" class="item m-30">
        <van-checkbox :name="v.Id"
          >{{ v.CardCode }} [{{ v.CardTypeName }}]</van-checkbox
        >
      </div>
    </van-checkbox-group>
    <!-- <van-empty
      v-if="!isShowSubmit && list.length == 0"
      description="暂无实体卡可绑定"
    /> -->
    <van-goods-action>
      <van-goods-action-button
        v-if="isShowSubmit"
        :loading="isSubmiting"
        color="var(--tc)"
        text="提交"
        @click="submit"
      />
      <van-goods-action-button
        color="var(--tc)"
        :loading="isSubmiting"
        @click="bindCard"
        text="绑卡"
        v-if="list.length > 0"
      />
    </van-goods-action>
  </div>
</template>

<script>
/**
 :class="canSend ? '' : 'c-bg-gray'"
 * 
 */
import { submitOrder, payOrder, getOrderDetail } from "@/api/order";
import { getUserCouponList } from "@/api/coupon";
import { sqbWxPay, sqbH5Pay } from "@/api/pay";
import { Circle } from "vant";

export default {
  name: "BindRealCard",
  props: {},
  data() {
    return {
      canSend: false,
      codeDiabled: false,
      form: {
        phone: "",
        code: "",
      },
      // list: [{ name: '会员卡1', id: '1' }, { name: '会员卡2', id: '2' }],
      list: [],
      memberList: [],
      isSubmiting: false,
      isShowSubmit: true,
    };
  },
  watch: {
    "form.phone"(val) {
      if (val.length === 11) {
        this.codeDiabled = false;
      } else {
        this.codeDiabled = true;
      }
    },
    "$store.state.vpnId"(val) {
      this.vpnId = val;
    },
  },
  created() {
    if (this.$root.isDev) {
      this.form.phone = "18010472599";
      this.form.code = "";
    }
    this.vpnId = this.$store.state.vpnId;
  },
  mounted() {},
  methods: {
    // 绑卡
    bindCard() {
      if (this.memberList.length === 0) {
        return this.$toast("请先选择会员卡");
      }
      const params = {
        MobilePhone: this.form.phone,
        MemberIds: this.memberList,
        VpnId: this.$store.state.vpnId,
      };
      this.isSubmiting = true;
      $http("wechath5/zh-cn/v1/member/bind", params, "post")
        .then((res) => {
          this.isSubmiting = false;
          this.$toast("绑卡成功");
          this.$router.push("/member/myMemberCard");
        })
        .catch(() => {
          this.isSubmiting = false;
        });
    },
    // 发送验证码
    sendCode() {
      $http(
        "wechath5/zh-cn/v1/member/sendsmscode?phone=" + this.form.phone
      ).then((res) => {
        this.$toast("发送验证码成功");
        this.$refs.sendRef.activeCode();
      });
    },
    // 提交
    submit() {
      if (!this.form.code.trim()) {
        return this.$toast("请先输入验证码");
      }
      let params = {
        MobilePhone: this.form.phone,
        SmsCode: this.form.code,
        VpnId: this.vpnId,
      };
      this.isSubmiting = true;
      $http("wechath5/zh-cn/v1/member/unbind", params)
        .then((res) => {
          this.isSubmiting = false;
          this.list = res;
          if (res.length == 0) {
            this.$toast("暂无实体卡可绑定，请重新输入");
            this.form.phone = "";
            this.form.code = "";
          } else {
            this.isShowSubmit = false;
          }
        })
        .catch(() => {
          this.isSubmiting = false;
        });
      /*  this.form.OpenId = this.$store.state.OpenId;
       this.form.WechatName = this.$store.state.loc.name;
 
       $http('wechath5/zh-cn/v1/member/bindcard', this.form, 'post').then(res => {
         this.$router.push('/member/myMemberCard');
       }) */
    },
    confirmBind() {},
    onFailed(errorInfo) {},
  },
};
</script>
<style scoped lang="scss">
.box {
  font-size: 28px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #333333;
}
.top {
  height: 66px;
  font-size: 48px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 40px;
}
.prefix {
  font-size: 26px;
}
.sub-top {
  height: 36px;
  font-size: 26px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #666666;
  margin-bottom: 50px;
  margin-top: 10px;
}
.wx-img {
  margin-right: 10px;
  object-fit: contain;
}
.l-img {
  margin-right: 20px;
}
.btm-btn,
.btm-btn2 {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 50%;
  border-radius: 0 !important;
  border: none;
  outline: none;
}
.btm-btn2 {
  right: 0;
  left: unset;
  /* background: unset; */
  background: var(--tc);
  color: #fff;
}
</style>
